import { render, staticRenderFns } from "./slotLayout.vue?vue&type=template&id=2bbbe326&"
import script from "./slotLayout.vue?vue&type=script&lang=js&"
export * from "./slotLayout.vue?vue&type=script&lang=js&"
import style0 from "./slotLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports